import styled from "styled-components";

export const LightButton = styled.button`
  background-color: #fff;
  border: none;
  color: #032b88;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
  border-radius: 110px;
  padding: 7px 25px;
  font-family: "Inter", sans-serif !important;
  animation: fade-in 0.5s forwards;

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .book-icon {
    margin-right: 10px;
    font-size: 24px;
  }
`;
